// Keskeneräisen treenin osoitin (osio 6.5).
//
// Tämän sovelluksen arkkitehtuurissa sarjat tallentuvat heti palvelimelle, joten
// koko treeni on jo turvassa palvelimella. localStorageen tallennetaan siksi
// kevyt OSOITIN käynnissä olevaan live-treeniin: sen avulla etusivu näyttää
// "Jatka keskeneräistä treeniä" -bannerin, jos selain suljettiin kesken.
// (Sovitus docin 6.5:een — perustelu DEVLOGissa.)
//
// serializeDraft / parseDraft ovat puhtaita → yksikkötestattavia (osio 11,
// testi #3): round-trip, rikkinäinen JSON → null, väärä versio → null.

export const LIVE_DRAFT_KEY = 'treeni.draft.v1';
const CURRENT_VERSION = 1;

export interface LiveWorkoutDraft {
  version: number;
  workoutId: string;
  name: string | null;
  startedAt: string; // ISO
  savedAt: string; // ISO — milloin osoitin viimeksi kirjoitettiin
}

export function serializeDraft(draft: LiveWorkoutDraft): string {
  return JSON.stringify(draft);
}

/**
 * Jäsennä osoitin. Palauttaa null hallitusti jos syöte on tyhjä, rikkinäistä
 * JSONia, väärää versiota tai puuttuu pakollisia kenttiä (ei koskaan heitä).
 */
export function parseDraft(raw: string | null | undefined): LiveWorkoutDraft | null {
  if (!raw) return null;
  let obj: unknown;
  try {
    obj = JSON.parse(raw);
  } catch {
    return null;
  }
  if (!obj || typeof obj !== 'object') return null;
  const d = obj as Record<string, unknown>;
  if (d.version !== CURRENT_VERSION) return null;
  if (typeof d.workoutId !== 'string' || d.workoutId.length === 0) return null;
  if (typeof d.startedAt !== 'string' || d.startedAt.length === 0) return null;
  return {
    version: CURRENT_VERSION,
    workoutId: d.workoutId,
    name: typeof d.name === 'string' ? d.name : null,
    startedAt: d.startedAt,
    savedAt: typeof d.savedAt === 'string' ? d.savedAt : d.startedAt,
  };
}

// ---- localStorage-kääriäiset (triviaali I/O, ei yksikkötestattu) ----

export function saveDraft(input: {
  workoutId: string;
  name: string | null;
  startedAt: string;
  savedAt?: string;
}): void {
  try {
    const draft: LiveWorkoutDraft = {
      version: CURRENT_VERSION,
      workoutId: input.workoutId,
      name: input.name,
      startedAt: input.startedAt,
      savedAt: input.savedAt ?? new Date().toISOString(),
    };
    localStorage.setItem(LIVE_DRAFT_KEY, serializeDraft(draft));
  } catch {
    /* localStorage ei käytettävissä — ei kriittistä */
  }
}

export function loadDraft(): LiveWorkoutDraft | null {
  try {
    return parseDraft(localStorage.getItem(LIVE_DRAFT_KEY));
  } catch {
    return null;
  }
}

export function clearDraft(): void {
  try {
    localStorage.removeItem(LIVE_DRAFT_KEY);
  } catch {
    /* ohita */
  }
}
